import {TrainingActivityViewModel} from './trainingActivity.viewModel';
import {TrainingDurationViewModel} from './trainingDuration.viewModel';

export class TrainingViewModel {
    day?: string;
    training_activity?: TrainingActivityViewModel;
    training_duration?: TrainingDurationViewModel;
}

export class DiaryTrainingViewModel {
    training_activity?: TrainingActivityViewModel;
    training_duration?: TrainingDurationViewModel;
}

export class DailyChangesActivityViewModel {
    id?: number;
    title?: string;
    multiple_per_kg?: number;
}

export class DiaryAdditionalDailyChangesViewModel {
    daily_changes_activity?: DailyChangesActivityViewModel;
    minutes?: number;
}

export class DiaryAdditionalTrainingViewModel {
    stress_level_temporary?: boolean;
    stress_level_constant?: boolean;
    brain_level_temporary?: boolean;
    brain_level_temporary_minutes?: number;
    additional_daily_changes?: DiaryAdditionalDailyChangesViewModel[];
}
